import useCommon from '@hooks/useCommon.js';
import { deepSignal } from 'deepsignal';
import { CHARITY } from '@util/const.js';
import {
  LifetimeOverlay,
  LifetimeOverlayBackgroundColors,
  toLifetimeOverlayBackgroundColor,
} from '@playlive/overlay-core/overlays/lifetime';
import ScaledOverlayWrapper from '@components/overlays/wrapper/scaled-overlay-wrapper.jsx';
import CustomizeSection from '@components/overlays/shared/customize-section.jsx';
import ColorPicker from '@components/pickers/color-picker/color.picker.jsx';
import LinkSetup from '@components/overlays/social/link-setup/link-setup.jsx';
import { useCallback } from 'preact/hooks';
import ColorPickerLabel from '@components/pickers/color-picker/color-picker-label.jsx';

const config = deepSignal({
  charityType: CHARITY.TILTIFY,
  bgColor: 'default-red',
});

export default function LifetimeRaisedPage() {
  const { overlayInfo, overlayURL, setConfigState } = useCommon({
    config,
    forceTiltify: true,
    addTiltifyCampaign: false,
  });

  const filterColors = useCallback(
    (color) => LifetimeOverlayBackgroundColors.find((c) => c === color),
    []
  );

  return (
    <div className="w-full overflow-x-hidden">
      <div className="flex flex-col overflow-hidden">
        <div className="example_overlay select-none overflow-hidden w-full">
          <ScaledOverlayWrapper
            className="h-[550px]"
            allowScaling={false}
            defaultScale="scale-100"
          >
            <LifetimeOverlay
              backgroundColor={toLifetimeOverlayBackgroundColor(config.bgColor)}
              currentAmount={1000}
            />
          </ScaledOverlayWrapper>
        </div>

        <div>
          <CustomizeSection title="Appearance">
            <ColorPickerLabel color={config.bgColor} />
            <ColorPicker
              fieldName="bgColor"
              currentColor={config.bgColor}
              filterFunction={filterColors}
              onChange={setConfigState}
            />
          </CustomizeSection>

          {/* Charity Section Placeholder */}
        </div>
      </div>

      <div className="w-full xl:mt-4">
        <LinkSetup
          showTiltifyCampaignSelector={false}
          constrainWidth={false}
          charityType={CHARITY.TILTIFY}
          obsDimensions={overlayInfo.obsDimensions}
          overlayName={overlayInfo.name}
          overlayURL={overlayURL}
        />
      </div>
    </div>
  );
}
